enum ResolveErrorType {
  QRCodeNotEnabled,
  ShopOffline,
}

export default ResolveErrorType
